import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import Data from "./data"


ReactDOM.render(<App />, document.getElementById("root"))